module.exports = __webpack_public_path__ + "static/media/map.2ae9507c.png";